//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getBrowser } from '@/utils/ua';
export default {
  name: 'error',
  props: {
    error: {
      type: Object,
      default: null
    },
    amount: {
      type: String,
      default: ''
    },
    logo: {
      type: String,
      default: ''
    }
  },
  methods: {
    getBrowser: getBrowser,
    // 关闭页面
    closePage: function closePage() {
      var ua = getBrowser();

      if (ua === 'wechat') {
        WeixinJSBridge.call('closeWindow'); // eslint-disable-line
      } else if (ua === 'alipay') {
        AlipayJSBridge.call('closeWebview'); // eslint-disable-line
      }
    }
  }
};